import AdminRoutes from "./Components/Admin/AdminRoutes";


function App() {
  return (
    <AdminRoutes />
  );
}

export default App;
